import { j as N } from "./CheveronLeft-BLchON5X.js";
import { r as a } from "./useCartUpsells-oN76HI6E.js";
import { f as j, u as R, c as k, a as M, b as $, d as J } from "./ShopifyCart-LdCOHsRZ.js";
import { C as p } from "./events-Dm1k7AS7.js";
import "./index-kA4PVysc.js";

const I = a.createContext(),
    K = ({ children: i }) => {
        const [o, d] = a.useState([]),
            [E, s] = a.useState(!1),
            [m, f] = a.useState(!1),
            [u, C] = a.useState([]),
            [g, n] = a.useState(""),
            [T, setSubtotal] = a.useState(0);

        a.useEffect(() => {
            S();
        }, []);

        const S = async () => {
                try {
                    s(!0);
                    const t = await j(),
                        e = t.items || [];
                    d(e), setSubtotal(t.total_price || 0), n(t.note || ""), await v(e);
                } catch (t) {
                    console.error("Error bootstrapping cart:", t), d([]), setSubtotal(0), n("");
                } finally {
                    s(!1);
                }
            },
            v = async (t = []) => {
                try {
                    if (t && t.length > 0) {
                        const r = t[t.length - 1];
                        if (r && r.product_id)
                            try {
                                const w = await fetch(
                                    `/recommendations/products.json?product_id=${r.product_id}&intent=complementary&limit=6`
                                );
                                if (w.ok) {
                                    const h = await w.json();
                                    if (h.products && h.products.length > 0) {
                                        C(h.products);
                                        return;
                                    } else {
                                        const x = await fetch(
                                            `/recommendations/products.json?product_id=${r.product_id}&intent=related&limit=6`
                                        );
                                        if (x.ok) {
                                            const y = await x.json();
                                            if (y.products && y.products.length > 0) {
                                                C(y.products);
                                                return;
                                            }
                                        }
                                    }
                                }
                            } catch {}
                    }
                    const e = document.querySelector("#upsell-products-json");
                    if (e) {
                        const r = JSON.parse(e.textContent).upsellProducts;
                        C(r);
                    }
                } catch (e) {
                    console.error("Error fetching upsell products:", e);
                }
            },
            c = async () => {
                try {
                    const t = await j(),
                        e = t.items || [];
                    d(e), setSubtotal(t.total_price || 0), n(t.note || ""), await v(e);
                } catch (t) {
                    console.error("Error fetching cart data:", t);
                }
            },
            _ = async (t, e = 1) => {
                try {
                    return s(!0), await J({ items: [{ id: t, quantity: e }] }), await c(), s(!1), Promise.resolve();
                } catch (r) {
                    return (
                        console.error("Error adding item:", r),
                        window.dispatchEvent(
                            new CustomEvent("cart:error", {
                                detail: {
                                    message: "Failed to add item to cart. Please try again.",
                                    title: "Cart Error",
                                },
                            })
                        ),
                        s(!1),
                        Promise.reject(r)
                    );
                }
            },
            q = async (t, e) => {
                try {
                    const r = { updates: { [t]: e } };
                    await $(r), await c();
                } catch (r) {
                    console.error("Error updating quantity:", r),
                        window.dispatchEvent(
                            new CustomEvent("cart:error", { detail: "Failed to update quantity. Please try again." })
                        );
                }
            },
            U = async (t) => {
                try {
                    const e = { id: String(t), quantity: 0 };
                    await M(e), await c();
                } catch (e) {
                    console.error("Error removing item:", e);
                }
            },
            P = () => {
                f(!m);
            },
            b = () => {
                f(!0);
            },
            A = () => {
                f(!1);
            },
            L = async () => {
                try {
                    await k(), d([]), setSubtotal(0), n("");
                } catch (t) {
                    console.error("Error clearing cart:", t),
                        window.dispatchEvent(
                            new CustomEvent("cart:error", { detail: "Failed to clear cart. Please try again." })
                        );
                }
            },
            O = async (t) => {
                try {
                    s(!0);
                    const e = await R(t);
                    return n(e.note || t), e;
                } catch (e) {
                    throw (
                        (console.error("Error updating cart note:", e),
                        window.dispatchEvent(
                            new CustomEvent("cart:error", { detail: "Failed to update note. Please try again." })
                        ),
                        e)
                    );
                } finally {
                    s(!1);
                }
            },
            l = o.reduce((t, e) => t + e.quantity, 0),
            D = a.useMemo(() => {
                if (!u || !o) return u;
                const t = o.map((e) => e.product_id);
                return u.filter((e) => !t.includes(e.id));
            }, [u, o]);

        a.useEffect(() => {
            document.dispatchEvent(new CustomEvent(p.COUNT_UPDATE, { detail: { count: l } }));
        }, [l]);

        a.useEffect(() => {
            const t = async () => {
                await c(), document.dispatchEvent(new CustomEvent(p.ADDED, { detail: { items: o } })), P();
            };
            return (
                document.addEventListener(p.ADD, t),
                () => {
                    document.removeEventListener(p.ADD, t);
                }
            );
        }, []);

        const F = a.useMemo(
            () => ({
                lineItems: o,
                isOpen: m,
                isLoading: E,
                toggleOpen: P,
                openCart: b,
                closeCart: A,
                addItem: _,
                updateQuantity: q,
                removeItem: U,
                clearCart: L,
                refreshCart: c,
                upsellProducts: D,
                subtotal: T,
                itemCount: l,
                note: g,
                updateNote: O,
            }),
            [o, m, E, D, T, l, g]
        );

        return N.jsx(I.Provider, { value: F, children: i });
    },
    V = () => {
        const i = a.useContext(I);
        if (!i) throw new Error("useCart must be used within a CartProvider");
        return i;
    };

export { K as C, V as u };